import { render, staticRenderFns } from "./AddonNew.vue?vue&type=template&id=1057e6de&scoped=true&"
import script from "./AddonNew.vue?vue&type=script&lang=js&"
export * from "./AddonNew.vue?vue&type=script&lang=js&"
import style0 from "./AddonNew.vue?vue&type=style&index=0&id=1057e6de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1057e6de",
  null
  
)

export default component.exports